<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .m-t-sm.pull-right(v-show="!onLoading('fetch-purchase-order')")
            .dropdown.inline
                button.md-btn.md-raised.m-b-sm.white.m-r-sm.w-xs.dropdown-toggle(
                    data-toggle="dropdown",
                    :disabled="isLoading",
                    aria-expanded="false"
                ) Action
                .dropdown-menu
                    a.dropdown-item(:href="printUrl", target="_blank")
                        i.material-icons.m-r-sm print
                        | Print
                    button.dropdown-item(
                        @click="email",
                        type="button",
                        :class="{ 'not-allowed': !canMail, 'text-muted': !canMail }",
                        :disabled="!canMail"
                    )
                        i.material-icons.m-r-sm mail_outline
                        | Mail

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Purchase Order
                li.breadcrumb-item.active {{ purchaseOrder.order_no }}

    .padding(v-show="!onLoading('fetch-purchase-order')")
        purchase-order-info
        purchase-order-stocks

        .box.dker(
            v-if="!hasFinalized",
            v-show="!onLoading('fetch-purchase-order')"
        )
            .box-body.text-right
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="isLoading",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green.m-r-sm(
                    :disabled="isLoading",
                    @click="saveChanges",
                    v-if="canEdit"
                )
                    v-loading(loader="save-purchase-order") Save

                button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green(
                    :disabled="isLoading",
                    @click="markOrdered",
                    v-if="isOpen && canUpdate"
                )
                    v-loading(loader="ordered-purchase-order") Mark as Ordered

                button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green(
                    :disabled="isLoading",
                    @click="markReceived",
                    v-if="isOrdered && canUpdate"
                )
                    v-loading(loader="received-purchase-order") Mark as Received
    
    purchase-order-email(ref="mail")
</template>

<script>
import purchaseOrderMixin from './purchase-order-mixin';
import purchaseOrderInfo from './purchase-order-edit-info.vue';
import purchaseOrderStocks from './purchase-order-edit-stocks.vue';
import purchaseOrderEmail from './purchase-order-email.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: {
        purchaseOrderStocks,
        purchaseOrderInfo,
        purchaseOrderEmail,
    },

    mixins: [purchaseOrderMixin],

    computed: {
        ...mapGetters('purchaseOrder', ['purchaseOrder', 'hasFinalized']),

        isLoading() {
            return (
                this.onLoading('save-purchase-order') ||
                this.onLoading('ordered-purchase-order') ||
                this.onLoading('received-purchase-order') ||
                this.onLoading('fetch-purchase-order')
            );
        },

        printUrl() {
            const id = this.$route.params.id;
            return Laroute.route('purchase_order.print', { id });
        },

        canMail() {
            return this.isOrdered && this.hasFinalized;
        },
    },

    watch: {
        '$route.params.id': function(id) {
            if (!_.isNil(id)) {
                this.getPurchaseOrder(id);
            }

            this.errors.clear();
        },
    },

    created() {
        this.getPurchaseOrder(this.$route.params.id);
    },

    methods: {
        ...mapActions('purchaseOrder', [
            'getPurchaseOrder',
            'updatePurchaseOrder',
        ]),

        cancel() {
            this.$router.push('/');
        },

        async saveChanges() {
            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updatePurchaseOrder();
                this.swal({ text: 'Purchase order has successfully saved' });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async markOrdered() {
            if (!this.validateStockExists()) return;

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updatePurchaseOrder({
                    actions: 'ordered',
                    status: this.statuses.ORDERED,
                });

                this.swal({
                    text: 'Purchase order has successfully ordered',
                });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async markReceived() {
            if (!this.validateStockExists()) return;

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updatePurchaseOrder({
                    actions: 'received',
                    status: this.statuses.RECEIVED,
                });

                this.swal({
                    text: 'Purchase order has successfully received',
                });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async validateForm() {
            const validate = await this.$validator.validate();

            if (!validate) {
                // focus on error input
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }
            }

            return validate;
        },

        validateStockExists() {
            if (!this.purchaseOrder.stocks.length) {
                this.swalWarning({ text: 'No stock added' });
                return false;
            }

            return true;
        },

        email() {
            this.$refs.mail.$emit('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/purchase-order/purchase-order-edit.vue